export enum DownloadOption {
  Filtered = 'filtered',
  Full = 'full',
}

export interface DownloadReportModalProps {
  show: boolean;
  isDownloading?: boolean;
  onHide: () => void;
  onDownload: (option: DownloadOption) => void;
}
